import React from "react";

export function calculateMeanAndStdDev(arr: number[]) {
  if (arr.length === 0) {
    return { mean: 0, standardDeviation: 0 };
  }
  const mean = arr.reduce((a, b) => a + b, 0) / arr.length;
  const standardDeviation = Math.sqrt(
    arr.reduce((a, b) => a + (b - mean) ** 2, 0) / arr.length,
  );
  return { mean, standardDeviation };
}

export function MatrixTable({ children }: { children: React.ReactNode }) {
  return (
    <table className="text-xs min-h-0 overflow-auto border-separate border-spacing-0">
      {children}
    </table>
  );
}

export function MatrixTableEl({ children }: { children: React.ReactNode }) {
  return (
    <div className="overflow-auto grid grid-cols-[auto] grid-rows-[auto] [grid-template-areas:'corner_cols'_'rows_body']">
      {children}
    </div>
  );
}
